import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { useResponsive } from "../drawerNavBar/use-responsive";
import Iconify from "../iconify/Iconify";
import Notifications from "../../utility/common/Notification";
import AccountPopover from "../account-popover/AccountPopOver";
import { HEADER, NAV } from "../../utility/common/config-layout";

interface UserProfileHeaderProps {
  onOpenNav: () => void;
}

export default function UserProfileHeader(props: UserProfileHeaderProps) {
  const { onOpenNav } = props;

  const theme = useTheme();

  const lgUp = useResponsive("up", "lg");

  const renderContent = (
    <>
      {!lgUp && (
        <IconButton onClick={onOpenNav} sx={{ mr: 1 }}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
      )}

      {/* <SearchBar /> */}

      <Box sx={{ flexGrow: 1 }} />

      <Stack direction="row" alignItems="center" spacing={1}>
        {/* <LanguagePopover /> */}
        <Notifications />
        <AccountPopover />
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        boxShadow: "none",
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        // ...bgBlur({
        //   color: theme.palette.background.default,
        // }),
        backdropFilter: "blur(6px)", // Blur effect on the background
        WebkitBackdropFilter: "blur(6px)", // For Safari compatibility
        backgroundColor: "rgba(255, 255, 255, 0.8)", // White color with 80% opacity
        transition: theme.transitions.create(["height"], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.WIDTH + 1}px)`,
          height: HEADER.H_DESKTOP,
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}

UserProfileHeader.propTypes = {
  onOpenNav: PropTypes.func,
};
